module.exports = __webpack_public_path__ + "media/application/images/svgs/minus-square-9bd1e5558d778c10d30cdf1d4db47359.svg";